document.addEventListener("DOMContentLoaded", () => {
    let popup = document.querySelector(".email-link-popup"),
        timerId = false;
    document.querySelectorAll("[href^=mailto]").forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            let email = link.href.replace(/mailto:(\/\/)?/, "");
            navigator.clipboard.writeText(email);
            popup.style.top = scrollY + e.clientY + "px";
            popup.style.left = scrollX + e.clientX + "px";
            popup.classList.add("is-show");
            if (timerId) clearTimeout(timerId);
            timerId = setTimeout(() => {
                popup.classList.remove("is-show");
            }, 1000);
        });
    });
    document.addEventListener("click", (e) => {
        if (!e.target.closest("[href^=mailto]")) {
            popup.classList.remove("is-show");
        }
    });
});
